"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWindowWithoutPopupBlocker = void 0;
var CRI_OS_REGEX = /CriOS/;
var CHROME = /Chrome/i;
var FIREFOX_REGEX = /Firefox/;
var SAFARI_REGEX = /Safari/;
function isChrome(userAgent) {
    return CRI_OS_REGEX.test(userAgent) || CHROME.test(userAgent);
}
function isSafari() {
    return SAFARI_REGEX.test(navigator.userAgent) && !isChrome(navigator.userAgent);
}
function isFirefox() {
    return FIREFOX_REGEX.test(navigator.userAgent) && !isChrome(navigator.userAgent);
}
function isPopupBlockerBrowser() {
    return isSafari() || isFirefox();
}
function createWindowWithoutPopupBlocker() {
    // When a new window is created, if it's not part of a click event handler it will be detected by browsers as a pop-up.
    // This is because we are opening a new window and we have some asynchronously logic such as publishing the workbook.
    // to get around the pop up blocker we need to open the window first, then the window.location.href can be set asynchronously afterwards
    if (isPopupBlockerBrowser()) {
        var windowReference = window.open();
        if (windowReference) {
            return windowReference;
        }
    }
    return undefined;
}
exports.createWindowWithoutPopupBlocker = createWindowWithoutPopupBlocker;
//# sourceMappingURL=Utils.js.map